<template>
  <v-tooltip
    top
    color="black"
    :max-width="maxWidth"
    :nudge-bottom="nudgeBottom"
  >
    <template #activator="{ on, attrs }">
      <span
        v-bind="attrs"
        ref="text"
        class="ellipses-text"
        v-on="showTooltip ? on : null"
        v-html="text"
      />
    </template>
    <span v-if="showTooltip" v-html="text" />
  </v-tooltip>
</template>

<script>
export default {
  name: 'EllipsisText',

  props: {
    text: {
      type: String,
      required: true
    }
  },

  data: () => ({
    showTooltip: false,
    maxWidth: 200,
    nudgeBottom: 0
  }),

  mounted() {
    setTimeout(() => {
      const refText = this.$refs.text
      this.showTooltip = refText.scrollHeight > refText.clientHeight
      this.maxWidth = refText.clientWidth
      this.nudgeBottom = refText.clientHeight
    }, 500)
  }
}
</script>

<style lang="scss" scoped>
.ellipses-text {
  display: block;
  display: -webkit-box;
  width: 100%;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
